import { UseMutationResult, useMutation } from "react-query";

import { useAxios } from "../../hooks/useAxios";

export interface IInitiateAvatarImageNOtificationArgs {
  email: string;
  avatar_image_url: string;
}

export interface IUseInitiateAvatarImageNotificationArgs {
  onSuccess?: () => void;
}

export function useInitiateAvatarImageNotification({
  onSuccess,
}: IUseInitiateAvatarImageNotificationArgs): UseMutationResult<
  unknown,
  unknown,
  IInitiateAvatarImageNOtificationArgs
> {
  const axios = useAxios();

  const initiateAvatarImageNotification = async (
    args: IInitiateAvatarImageNOtificationArgs
  ) => {
    const { email, avatar_image_url } = args;

    const response = await axios({
      method: "post",
      url: `/v1/notifications/avatar-image`,
      data: {
        email,
        avatar_image_url,
      },
    });

    return response;
  };

  const mutation = useMutation(initiateAvatarImageNotification, { onSuccess });

  return {
    ...mutation,
  };
}
